import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, mergeMap } from "rxjs/operators";
import { IAMAccountActions } from "../actions";
import {
  IAMAccountPasswordUpdateRequestDTO,
  IAMAccountSignInRequestDTO
} from "../dtos";
import { IAMAccountService } from "../services";

@Injectable()
export class IAMAccountEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly iamAccountService: IAMAccountService
  ) {}

  iamAccountPasswordUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IAMAccountActions.iamAccountPasswordUpdate),
      exhaustMap((_) =>
        this.iamAccountService
          .iamAccountPasswordUpdate(
            new IAMAccountPasswordUpdateRequestDTO({
              currentPassword:
                _.iamAccountPasswordUpdateCmd.value.currentPassword,
              newPassword: _.iamAccountPasswordUpdateCmd.value.newPassword
            })
          )
          .pipe(
            mergeMap(() => [
              IAMAccountActions.iamAccountPasswordUpdateSuccess()
            ]),
            catchError((_: Error) => [
              IAMAccountActions.iamAccountPasswordUpdateFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  iamAccountSignIn$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IAMAccountActions.iamAccountSignIn),
      exhaustMap((_) =>
        this.iamAccountService
          .iamAccountSignIn(
            new IAMAccountSignInRequestDTO({
              identity: _.iamAccountSignInCmd.value.identity,
              password: _.iamAccountSignInCmd.value.password
            })
          )
          .pipe(
            mergeMap((_) => [
              IAMAccountActions.iamAccountSignInSuccess({
                jwt: _.data.accountJwt
              })
            ]),
            catchError((_: Error) => [
              IAMAccountActions.iamAccountSignInFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );
}
